import { TOKENS } from "../../../App";
import { searchParams } from "../../../helpers/utils";
import Lablife4BirthResult from "./Lablife4BirthResult";
import LablifeBfpResult from "./LablifeBfpResult";

interface ResultProps {
  token: string;
  partner: string;
  data: any;
}

export const Result = (props: ResultProps) => {
  const sp = searchParams();

  if (props.token === TOKENS.LABLIFE_4_BIRTH || props.token === TOKENS.LABLIFE_NEW_FREE_4_BIRTH) {
    return <Lablife4BirthResult data={props.data} />;
  }

  if (props.token === TOKENS.LABLIFE_BFP) {
    if (sp.get('email')) {
      return <LablifeBfpResult token={props.token} partner={props.partner} />;
    }

    return <h1 style={{marginTop:'200px', marginBottom: '200px'}}>На вашу почту отправлено письмо с результатами</h1>;
  }

  return null
}
